import { render, staticRenderFns } from "./CommentIng.vue?vue&type=template&id=0bfda637&scoped=true&"
import script from "./CommentIng.vue?vue&type=script&lang=js&"
export * from "./CommentIng.vue?vue&type=script&lang=js&"
import style0 from "./CommentIng.vue?vue&type=style&index=0&id=0bfda637&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfda637",
  null
  
)

export default component.exports